import { RowDetail } from '@/main/store/@types/list.d';
import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { apiProvider } from '../../api';
import { NAME, CRUMB_LABEL_KEY } from '../../constants';
import { types } from './constants';

const filter = {
	KaroserieNr: '',
	Spz: null,
	Typkod: null,
	Tablpozice: null,
	VyrobekvozOzn: null,
	ZakaznikId: null,
	ZakaznikIdText: null,
	ModelRok: null,
	MotorKod: null,
	MotorNr: null,
	PrevodKod: null,
	BarvaText: null,
	GarPzn: null,
	ProdejzdePrp: null,
	ProdejzdeOvPrp: null,
	ProdejDatOd: null,
	ProdejDatDo: null,
	StkplatDatOd: null,
	StkplatDatDo: null,
	StkDatOd: null,
	StkDatDo: null,
	GarKonecDatOd: null,
	GarKonecDatDo: null,
	LeaszakaznikId: null,
	LeaszakaznikIdText: null,
	LeassmlouNr: null,
	Leaspodminky: null,
	LeasKonecDatOd: null,
	LeasKonecDatDo: null,
	PojistovnaId: null,
	PojistovnaIdText: null,
	PojistsmlNr: null,
	VrJmeno: null,
	VrPrijmeni: null,
	VrTelNr: null,
	VrEMailAdresa: null,
	VrRpNr: null,
	IdDoklNr: null,
	IsApprovalRole: null as boolean | null,
	ApprovalStatus: null,
};

export class VozidloRowDetail implements RowDetail {
	loadingCount: number = 0;
	Partner = {
		Adresa: null,
		IcoNr: null,
		Jmeno: null,
		TelefonNr: null,
		Text: null,
		TextJmeno: null,
		ZakaznikId: null,
	};

	RelatedData = {
		OdlozenyServisPoc: null,
		PneusetNaSkladePoc: null,
		SdaAktivniPoc: null,
		ZakazkaOtevrenaPoc: null,
		ZakazkaPosledniNajezd: null,
		ZakazkaPosledniOtevreniDat: null,
		ZakazkaVsechnyPoc: null,
	};

	Vozidlo = {
		KaroserieNr: null,
		Objem: null,
		Spz: null,
		VozidloId: null,
		Vybava: null,
		Vykon: null,
		VyrobaDat: null,
		VyrobaRok: null,
		VyrobekoznText: null,
		zakaznkId: null,
	};
}

export const store = listStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		VyrobekvozOzn: [],
		Tablpozice: [],
		Typkod: [],
		GarPzn: [],
		ApprovalStatus: [],
	},
	filter,
	tableSetting: {},
	rowDetail: new VozidloRowDetail(),
	localState: {},
	extraActions: {},
	extraMutations: {
		[types.mutations.VOZIDLO_ZAKAZNIK_FILTER_SELECT_MAPPER](state, { data, mode }) {
			state.filter.ZakaznikId = data.value;
			state.filter.ZakaznikIdText = data.text;
		},
		[types.mutations.VOZIDLO_LEASING_ZAKAZNIK_FILTER_SELECT_MAPPER](state, { data, mode }) {
			state.filter.LeaszakaznikId = data.value;
			state.filter.LeaszakaznikIdText = data.text;
		},
		[types.mutations.VOZIDLO_POJISTOVNA_FILTER_SELECT_MAPPER](state, { data, mode }) {
			state.filter.PojistovnaId = data.value;
			state.filter.PojistovnaIdText = data.text;
		},
	},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
		afterRowSelection: () => {},
	},
});
